import React from 'react';

export interface CtaCardProps {
  title: string;
  description: string;
  action: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export const CtaCard = ({ title, description, action, icon, onClick }: CtaCardProps) => (
  <div className="w-full bg-[#231a1a] border border-dashed border-white/10 rounded-[14px] p-[15px] flex items-center gap-3">
    <div className="flex-shrink-0 w-[38px] h-[38px] rounded-full bg-[rgba(215,46,22,0.08)] flex items-center justify-center text-[#d72e16]">
      <div className="w-[18px] h-[18px] flex items-center justify-center">
        {icon}
      </div>
    </div>
    <div className="flex-1 min-w-0 flex flex-col gap-[2px]">
      <p className="text-[13px] font-semibold text-white leading-[1.5]">{title}</p>
      <p className="text-[11px] text-[#8d8d8d] leading-[1.4]">{description}</p>
    </div>
    <button
      onClick={onClick}
      className="flex-shrink-0 px-[14px] py-[7px] rounded-full bg-[#d72e16] text-white text-[12px] font-semibold whitespace-nowrap active:opacity-80 transition-opacity"
    >
      {action}
    </button>
  </div>
);
